import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import BoletoUrls from './BoletoUrls';
import InvoiceAndFapiaoLinks from './InvoiceAndFapiaoLinks';
import OrderCertificate from './OrderCertificate';
import OrderDates from './OrderDates';
import OrderPanelHeader from './OrderPanelHeader';
import OrderReeditLink from './OrderReeditLink';
import OrderServices from './OrderServices';
var OrderPanel = function OrderPanel(_ref) {
  var addMessage = _ref.addMessage,
    displayInvoices = _ref.displayInvoices,
    getDownloadUrl = _ref.getDownloadUrl,
    order = _ref.order,
    pathname = _ref.pathname,
    status = _ref.status,
    updateCertificate = _ref.updateCertificate;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "order-panel"
  }, /*#__PURE__*/React.createElement(OrderPanelHeader, {
    awaitingPayment: order.completed && !order.paid,
    order: order,
    pathname: pathname
  }), /*#__PURE__*/React.createElement("div", {
    className: "row order-panel-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3 order-dates-wrapper order-information-column pt-1 pb-4"
  }, /*#__PURE__*/React.createElement(OrderDates, {
    showExactTime: false,
    deadlineAvailable: order.deadlineAvailable,
    order: order
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3 order-services-wrapper order-information-column pt-1 pb-4"
  }, /*#__PURE__*/React.createElement(OrderServices, {
    orderServices: order.services
  })), order.completed ? /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3 pt-4 pb-sm-4"
  }, order.completed && !order.paid && !order.downloadAvailable ? /*#__PURE__*/React.createElement(T.md, {
    source: "completed-files-awaiting-payment",
    inline: true,
    params: {
      supportLink: "/support/index/submission/".concat(order.externalId, "/type/proof-of-payment")
    }
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, order.downloadAvailable ? /*#__PURE__*/React.createElement(React.Fragment, null, order.retrievingDownload ? /*#__PURE__*/React.createElement("div", {
    className: "btn btn-primary action-button download-button py-2 d-block w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress my-2"
  }, /*#__PURE__*/React.createElement("div", {
    "aria-label": t('Download progress'),
    className: "progress-bar",
    role: "progressbar",
    style: {
      width: "".concat(order.downloadPercentage, "%")
    },
    "aria-valuenow": order.downloadPercentage,
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  })), /*#__PURE__*/React.createElement(T, {
    source: "Downloading..."
  })) : /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Download All Files'),
    type: "button",
    onClick: function onClick() {
      return getDownloadUrl(order.externalId);
    },
    className: "btn btn-primary action-button download-button py-2 d-block w-100"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "mb-2 d-block",
    icon: "fa-solid fa-download",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Download All Files"
  }))) : null)) : /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-3 text-start text-md-right pt-4 pb-4"
  }, displayInvoices ? /*#__PURE__*/React.createElement(InvoiceAndFapiaoLinks, {
    orderNumber: order.externalId
  }) : null, /*#__PURE__*/React.createElement(BoletoUrls, {
    order: order
  }), displayInvoices && !order.downloadAvailable ? /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Record payment'),
    className: "action-link d-block",
    href: "/support/index/submission/".concat(order.externalId, "/type/proof-of-payment"),
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Record payment"
  })) : null, /*#__PURE__*/React.createElement(OrderCertificate, {
    addMessage: addMessage,
    saving: status.savingCertificate,
    order: order,
    updateCertificate: updateCertificate
  }), /*#__PURE__*/React.createElement(OrderReeditLink, {
    order: order
  }), /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Contact support'),
    className: "action-link d-block",
    href: "/support/index/submission/".concat(order.externalId, "/type/support"),
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Contact support"
  })))));
};
export default OrderPanel;